import type { FC } from 'react'
import React, { ReactNode } from 'react'

interface ConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  content: ReactNode
  icon?: ReactNode
  buttons: ReactNode
  showBackdrop?: boolean
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  icon,
  buttons,
  showBackdrop = true
}) => {
  if (!isOpen) return null

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center ${showBackdrop ? 'bg-black/45' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className='w-[638px] px-6 py-8 rounded-[28px] bg-white shadow-popover'>
        <div className='flex'>
          {/* Icon Section */}
          {icon && <div className='mr-3 flex-shrink-0'>{icon}</div>}

          {/* Content Section */}
          <div className='flex-1'>
            {/* Title */}
            <h2 className='text-[rgba(0,0,0,0.88)] text-[20px] font-bold leading-[22px] mb-8'>
              {title}
            </h2>

            {/* Content */}
            <p className='text-base text-[rgba(0,0,0,0.88)] font-medium leading-[22px] mb-12'>
              {content}
            </p>

            {/* Footer */}
            <div className='flex justify-end'>{buttons}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
